import type { CampaignSelectDto } from '@@types/api.types';
import { BadgeList } from '@components/shared/badge-list.component';
import { BlueLabel } from '@components/shared/blue-label.component';
import { Tile } from '@components/shared/tile.component';
import { Badge } from '@components/ui/badge';
import { EditIcon } from 'lucide-react';
import type { FC } from 'react';

type CampaignDecisivePointsTileProps = {
  campaign: CampaignSelectDto;
  onEdit: () => void;
};

export const CampaignDecisivePointsTile: FC<CampaignDecisivePointsTileProps> = (props) => {
  const { campaign, onEdit } = props;
  const decisivePoints = campaign.decisivePoints;
  const isEmpty = decisivePoints.length === 0;

  return (
    <Tile
      emptyState={{
        message: '+ Add Decisive Point',
        onClick: onEdit,
        title: 'No Decisive Points',
      }}
      header={{
        iconButton: { ariaLabel: 'Edit decisive points', icon: <EditIcon />, onClick: onEdit },
        title: 'Decisive Points',
      }}
      hoverReveal
      isEmpty={isEmpty}
    >
      <div className="flex flex-col gap-2">
        {decisivePoints.map((point) => (
          <div
            className="relative flex flex-col gap-2 rounded-md border border-gray-200 p-3 pr-20"
            key={point.id}
          >
            <Badge
              className="absolute top-3 right-3"
              size="xs"
              variant="outline"
            >
              Rank {point.position + 1}
            </Badge>
            <p className="whitespace-pre-wrap text-sm text-gray-800">{point.description}</p>
            <BlueLabel
              className="-mt-1"
              text="Decisive Point"
            />
            {point.location && (
              <div className="flex flex-col gap-0.5">
                <p className="text-sm text-gray-500">{point.location}</p>
                <BlueLabel text="Location" />
              </div>
            )}
            {point.evidence.length > 0 && (
              <BadgeList
                badgeVariant="outline"
                items={point.evidence.map((entry, index) => ({ id: `${point.id}-evidence-${index}`, name: entry }))}
                limit={2}
                size="xs"
              />
            )}
          </div>
        ))}
      </div>
    </Tile>
  );
};
